export default function Services() {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our Expert Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From emergency tree removal to complete stump grinding, we provide comprehensive solutions for all your tree care needs with professional expertise and state-of-the-art equipment.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform hover:scale-105 transition-all duration-300">
            <div className="relative h-64">
              <img
                src="https://public.readdy.ai/ai/img_res/e3c48b132de139828a5444ee75867948.jpg"
                alt="Tree trimmer high up in a palm tree removing old fronds"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
                  <i className="fas fa-tree text-white text-xl"></i>
                </div>
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Tree Removal</h3>
              <p className="text-gray-600 mb-6">
                Safe and efficient removal of hazardous, diseased, or unwanted trees. Our experienced professionals use advanced techniques to protect your property during the removal process.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center">
                  <i className="fas fa-check text-green-600 mr-3"></i>
                  Emergency Tree Removal
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-green-600 mr-3"></i>
                  Crown Reduction & Pruning
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-green-600 mr-3"></i>
                  Total Tree Management
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform hover:scale-105 transition-all duration-300">
            <div className="relative h-64">
              <img
                src="https://readdy.ai/api/search-image?query=Heavy-duty%20professional%20stump%20grinding%20machine%20in%20action%20removing%20large%20tree%20stump%20in%20residential%20yard%2C%20wood%20chips%20flying%20from%20grinder%2C%20operator%20in%20safety%20vest%20controlling%20equipment%2C%20clean%20suburban%20lawn%20setting%20with%20fence%20and%20garden%20in%20background%2C%20bright%20sunny%20day%20with%20natural%20lighting%2C%20modern%20stump%20removal%20service&width=800&height=600&seq=stump-grinding-service-001&orientation=landscape"
                alt="Tree stump grinding machine removes stump in forest"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
                  <i className="fas fa-cog text-white text-xl"></i>
                </div>
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Stump Grinding</h3>
              <p className="text-gray-600 mb-6">
                Complete stump removal using professional-grade grinding equipment. We eliminate unsightly stumps and restore your landscape to its natural beauty.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center">
                  <i className="fas fa-check text-green-600 mr-3"></i>
                  Complete Stump Removal
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-green-600 mr-3"></i>
                  Root System Grinding
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-green-600 mr-3"></i>
                  Site Cleanup & Restoration
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Additional Services</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-exclamation-triangle text-2xl text-green-600"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Emergency Services</h4>
              <p className="text-sm text-gray-600">24/7 Storm Damage And Emergency Tree Removal</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-truck text-2xl text-green-600"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Debris Removal</h4>
              <p className="text-sm text-gray-600">Complete Cleanup And Hauling Services</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-seedling text-2xl text-green-600"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Land Clearing</h4>
              <p className="text-sm text-gray-600">Lot Preparation And Vegetation Management</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-clipboard-check text-2xl text-green-600"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Palm Tree Maintenance</h4>
              <p className="text-sm text-gray-600">Maintenance And Removal</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
